const roundNumber = (number) => {
  const n = Number(number || 0)

  return Math.ceil(n / 100) * 100
}

export default roundNumber